import { APP } from '../config/app';

export const buildWhatsappUrl = (message) => {
  const text = encodeURIComponent(message);
  return `https://wa.me/${APP.supportWhatsapp}?text=${text}`;
};

export const openWhatsappSupport = (message) => {
  window.open(buildWhatsappUrl(message), '_blank', 'noopener,noreferrer');
};

export const buildOrderHelpMessage = ({ orderId, status, shopName, total }) => {
  const lines = [
    'Hi MyTownly, I need help with my grocery order.',
    '',
    orderId ? `Order: #${orderId.slice(0, 8)}` : null,
    shopName ? `Shop: ${shopName}` : null,
    status ? `Status: ${status}` : null,
    total != null ? `Total: ₹${total}` : null,
    `Area: ${APP.town}`,
  ].filter(Boolean);
  return lines.join('\n');
};
